var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 35.5C15 24.4543 23.9543 15.5 35 15.5H45C56.0457 15.5 65 24.4543 65 35.5V45.5C65 56.5457 56.0457 65.5 45 65.5H35C23.9543 65.5 15 56.5457 15 45.5V35.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40.5C15 26.6929 26.1929 15.5 40 15.5C53.8071 15.5 65 26.6929 65 40.5C65 54.3071 53.8071 65.5 40 65.5C26.1929 65.5 15 54.3071 15 40.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6719 23.833H23.3385C21.0469 23.833 19.1927 25.708 19.1927 27.9997L19.1719 52.9997C19.1719 55.2913 21.0469 57.1663 23.3385 57.1663H56.6719C58.9635 57.1663 60.8385 55.2913 60.8385 52.9997V27.9997C60.8385 25.708 58.9635 23.833 56.6719 23.833ZM23.3398 32.166L40.0065 42.5827L56.6732 32.166V52.9993H23.3398V32.166ZM23.3398 28L40.0065 38.4167L56.6732 28H23.3398Z",
    fill: "#D1337F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#D1337F",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.49028fb15df475806f2774f3768d1086.svg";
export { ForwardRef as ReactComponent };